import React from 'react';
import PropTypes from 'prop-types';
import logo from "../../../../../../../../assets/images/experience_balnk.svg";
import ImageHelper from "../../../../../../../../utilities/helpers/ImageHelper";

const ExperienceItem = ({ experience }) => {
	return (
		<div
			key={experience.id}
			className="experience-row-container"
			style={{ marginBottom: '16px' }}
			data-testid="participant-item"
		>
			<div style={{ display: 'flex' }}>
				<div className="custom-experience-image-container">
					<img
						onError={(e) => {
							e.currentTarget.src = logo;
						}}
						src={experience?.thumbnail_url ? ImageHelper.getFullImageUrl(experience?.thumbnail_url) : logo}
						className="custom-experience-image"
					/>
				</div>
				<div>
					<h4
						style={{ marginLeft: '8px' }}
					>
						{experience.title} - <span style={{color: experience.status.color}}>{experience.status.title}</span>
					</h4>
					<h4
						style={{ fontWeight: 'normal', marginLeft: '8px', marginTop: '3px', cursor: 'pointer' }}
						className='text-with-underline'
						onClick={() => window.open(experience.share_url, '_blank')}
					>
						{experience.share_url}
					</h4>
				</div>
			</div>
		</div>
	);
};

ExperienceItem.propTypes = {
	experience: PropTypes.object.isRequired
};

export default ExperienceItem;
